import {
    WorkflowUsageDetailsSearchFiltersState,
    WorkflowUsageDetailsSearchResults
} from "@idw-types/state/workflow-usage-details-state";

export enum WorkflowUsageDetailsActionTypes {
    SET_WORKFLOW_USAGE_DETAILS_SEARCH_FILTERS = "SET_WORKFLOW_USAGE_DETAILS_SEARCH_FILTERS",
    SET_WORKFLOW_USAGE_DETAILS_SEARCH_RESULTS_LOADING = "SET_WORKFLOW_USAGE_DETAILS_SEARCH_RESULTS_LOADING",
    SET_WORKFLOW_USAGE_DETAILS_SEARCH_RESULTS = "SET_WORKFLOW_USAGE_DETAILS_SEARCH_RESULTS"
}

type SetWorkflowUsageDetailsSearchFiltersAction = {
    type: WorkflowUsageDetailsActionTypes.SET_WORKFLOW_USAGE_DETAILS_SEARCH_FILTERS;
    payload: { searchFilters: WorkflowUsageDetailsSearchFiltersState };
};

export const setWorkflowUsageDetailsSearchFilters = (
    searchFilters: WorkflowUsageDetailsSearchFiltersState
): SetWorkflowUsageDetailsSearchFiltersAction => ({
    type: WorkflowUsageDetailsActionTypes.SET_WORKFLOW_USAGE_DETAILS_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetWorkflowUsageDetailsSearchResultsLoadingAction = {
    type: WorkflowUsageDetailsActionTypes.SET_WORKFLOW_USAGE_DETAILS_SEARCH_RESULTS_LOADING;
    payload: { isLoading: boolean };
};

export const setWorkflowUsageDetailsSearchResultsLoading = (
    isLoading: boolean
): SetWorkflowUsageDetailsSearchResultsLoadingAction => ({
    type: WorkflowUsageDetailsActionTypes.SET_WORKFLOW_USAGE_DETAILS_SEARCH_RESULTS_LOADING,
    payload: { isLoading }
});

type SetWorkflowUsageDetailsSearchResultsAction = {
    type: WorkflowUsageDetailsActionTypes.SET_WORKFLOW_USAGE_DETAILS_SEARCH_RESULTS;
    payload: { workflowUsageDetailsSearchResults: WorkflowUsageDetailsSearchResults };
};

export const setWorkflowUsageDetailsSearchResults = (
    workflowUsageDetailsSearchResults: WorkflowUsageDetailsSearchResults
): SetWorkflowUsageDetailsSearchResultsAction => ({
    type: WorkflowUsageDetailsActionTypes.SET_WORKFLOW_USAGE_DETAILS_SEARCH_RESULTS,
    payload: { workflowUsageDetailsSearchResults }
});

export type WorkflowUsageDetailsActions =
    SetWorkflowUsageDetailsSearchFiltersAction |
    SetWorkflowUsageDetailsSearchResultsLoadingAction |
    SetWorkflowUsageDetailsSearchResultsAction